import React from 'react';
import Card from './ui/Card.jsx';

export default function StudyPlanPrintLayout({ plan, studentName, cin, campusEmail, printDate }) {
  const safePlan = plan || {};
  const cat3 = joinCourses([safePlan.cat31, safePlan.cat32]);
  const cat4 = joinCourses([safePlan.cat41, safePlan.cat42]);
  const electives = joinCourses([safePlan.ec1, safePlan.ec2, safePlan.ec3, safePlan.ec4, safePlan.ec5, safePlan.ec6]);
  const qualCourses = joinCourses([safePlan.qc1, safePlan.qc2, safePlan.qc3, safePlan.qc4, safePlan.qc5]);
  const prereqCourses = joinCourses([safePlan.pc1, safePlan.pc2, safePlan.pc3, safePlan.pc4, safePlan.pc5]);

  return (
    <>
      <div className="print-only print-plan-title">
        <div className="print-plan-title-line">California State University Los Angeles</div>
        <div className="print-plan-title-line">Department of Electrical and Computer Engineering</div>
        <div className="print-plan-title-line print-plan-title-main">MS Study Plan</div>
      </div>

      <Card title="Student Info" className="print-only">
        <div className="summary-list">
          <div className="summary-row">
            <span>Name</span>
            <span>{studentName || '—'}</span>
          </div>
          <div className="summary-row">
            <span>CIN</span>
            <span>{cin || '—'}</span>
          </div>
          <div className="summary-row">
            <span>Campus Email</span>
            <span>{campusEmail || '—'}</span>
          </div>
        </div>
      </Card>

      <div className="grid two print-only">
        <Card title="Core Categories">
          <div className="plan-list">
            <div className="plan-row">
              <span>Category 1</span>
              <span>{safePlan.cat1 || '—'}</span>
            </div>
            <div className="plan-row">
              <span>Category 2</span>
              <span>{safePlan.cat2 || '—'}</span>
            </div>
            <div className="plan-row">
              <span>Category 3</span>
              <span>{cat3 || '—'}</span>
            </div>
            <div className="plan-row">
              <span>Category 4</span>
              <span>{cat4 || '—'}</span>
            </div>
          </div>
        </Card>
        <Card title="Electives & Requirements">
          <div className="plan-list">
            <div className="plan-row">
              <span>Electives</span>
              <span>{electives || '—'}</span>
            </div>
            {safePlan.qual_needed === 1 ? (
              <div className="plan-row">
                <span>Qualification Courses</span>
                <span>{qualCourses || '—'}</span>
              </div>
            ) : null}
            {safePlan.prereq_needed === 1 ? (
              <div className="plan-row">
                <span>Prerequisite Courses</span>
                <span>{prereqCourses || '—'}</span>
              </div>
            ) : null}
          </div>
        </Card>
      </div>

      <Card title="Completion Options" className="print-only">
        <div className="plan-list">
          <div className="plan-row">
            <span>Option</span>
            <span>{completionOptionLabel(safePlan)}</span>
          </div>
        </div>
      </Card>

      <p className="print-footer">Accessed on {printDate}</p>
    </>
  );
}

function joinCourses(list) {
  return list
    .map((item) => (item || '').trim())
    .filter(Boolean)
    .join(', ');
}

function completionOptionLabel(plan) {
  if (plan.thesis === 1) return 'Thesis';
  return 'Comprehensive Exam';
}
